/**
 * 型番検索 của tab インク / トナー trang chủ — port `addPrinterWordInk` /
 * `addPrinterWord02` (vm_topPageSearch.tpl.php:164-232 và
 * `browse/includes/toppage_toner_tab_component.tpl.php:30-88`).
 *
 * Hành vi 1:1 site cũ:
 *  - <2 ký tự → xoá + ẩn hẳn khối kết quả, KHÔNG gọi API.
 *  - debounce 500ms trên `input` + `keyup`.
 *  - trần 40 request/phút (cửa sổ trượt 60s), vượt → chỉ `console.warn`, bỏ request.
 *  - Không có kết quả →「一致するものがありません。」
 *  - Kết quả nhóm theo maker: tiêu đề maker + list 型番 (site cũ `resultTit` + `<ul><li><a>`).
 *
 * Link: site cũ trỏ `/index.php/{category_name}.html`; ở đây là collection Shopify
 * `/collections/{handle}` — handle từ API, thiếu thì derive handleize(category_name)
 * (giống chip 適合プリンター + search overlay); collection không tồn tại → 404 native.
 *
 * API: GET /apps/ink/api/v1/search/printer-suggestions?q={kw}&category_type={IIP|TTP}
 *   Response: { data: { groups: [{ maker_name, items: [{ display_name,
 *     category_name, shopify_collection_handle, ... }] }], total } }
 *
 * Class `.ik-pms__*` của markup sinh trong file này khai ở `src/tailwind.css`
 * (Tailwind JIT không scan string JS).
 */
(function () {
  'use strict';

  const MIN_CHARS = 2;
  const DEBOUNCE_MS = 500;
  const MAX_REQUESTS_PER_MINUTE = 40;
  const RATE_WINDOW_MS = 60000;

  // Bộ đếm dùng chung cho mọi ô 型番 trên trang (site cũ đếm riêng mỗi tab, nhưng
  // cùng ngưỡng 40 — gộp là chặt hơn, không nới lỏng giới hạn).
  let requestCount = 0;
  let rateWindowStart = Date.now();

  function withinRateLimit() {
    const now = Date.now();
    if (now - rateWindowStart > RATE_WINDOW_MS) {
      rateWindowStart = now;
      requestCount = 0;
    }
    if (requestCount >= MAX_REQUESTS_PER_MINUTE) {
      console.warn('1分間に40回のリクエストの上限に達しました。しばらくお待ちください。');
      return false;
    }
    requestCount += 1;
    return true;
  }

  // `api-client.js` load cuối body → inkApi có thể chưa tồn tại lúc user gõ ký tự
  // đầu; chờ event `ink:api:ready` thay vì bỏ request im lặng.
  function whenApiReady(timeoutMs) {
    if (window.inkApi) return Promise.resolve(window.inkApi);
    return new Promise((resolve) => {
      const done = () => resolve(window.inkApi || null);
      document.addEventListener('ink:api:ready', done, { once: true });
      setTimeout(done, timeoutMs);
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(
      /[&<>"']/g,
      (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]),
    );
  }

  // Handleize giống Liquid filter: lowercase, ký tự không phải chữ/số → '-', trim '-'.
  function handleize(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/[^\p{L}\p{N}]+/gu, '-')
      .replace(/^-+|-+$/g, '');
  }

  function collectionUrl(item) {
    const handle = item.shopify_collection_handle || handleize(item.category_name);
    // Handle rỗng (tên toàn ký tự đặc biệt) → giữ tên raw để chắc chắn 404, tránh
    // `/collections/` trần (Shopify render danh sách toàn bộ collection).
    return '/collections/' + (handle || encodeURIComponent(item.category_name || 'not-found'));
  }

  function groupsHtml(groups) {
    return groups
      .map((g) => {
        const items = (g.items || [])
          .map((it) => `<li><a href="${esc(collectionUrl(it))}">${esc(it.display_name)}</a></li>`)
          .join('');
        return `<div class="ik-pms__tit">${esc(g.maker_name)}</div><ul class="ik-pms__list">${items}</ul>`;
      })
      .join('');
  }

  function bind(input) {
    if (input.dataset.inkPmsBound === '1') return;
    input.dataset.inkPmsBound = '1';

    const box = input.closest('[data-ink-pms]');
    const result = box.querySelector('[data-ink-pms-result]');
    const loading = box.querySelector('[data-ink-pms-loading]');
    const categoryType = input.dataset.inkPmsType || 'A';
    let timer = null;
    let seq = 0;

    function hideAll() {
      result.innerHTML = '';
      result.classList.add('hidden');
      loading.classList.add('hidden');
    }

    async function search() {
      const word = input.value.trim();
      if (word.length < MIN_CHARS) {
        hideAll();
        return;
      }
      if (!withinRateLimit()) return;

      const ticket = ++seq;
      result.classList.add('hidden');
      loading.classList.remove('hidden');

      const api = await whenApiReady(3000);
      if (!api) {
        if (ticket === seq) hideAll();
        return;
      }

      let res;
      try {
        res = await api.get('/search/printer-suggestions', { q: word, category_type: categoryType });
      } catch (e) {
        console.warn('printer-suggestions load fail', e);
        // Fail-open: ẩn khối kết quả, list maker phía dưới vẫn dùng được.
        if (ticket === seq) hideAll();
        return;
      }
      // Response về sau khi user đã gõ tiếp → bỏ, tránh ghi đè kết quả mới hơn.
      if (ticket !== seq) return;

      const data = (res && res.data) || {};
      const groups = Array.isArray(data.groups) ? data.groups : [];
      loading.classList.add('hidden');
      result.innerHTML = groups.length
        ? groupsHtml(groups)
        : '<p class="ik-pms__empty">一致するものがありません。</p>';
      result.classList.remove('hidden');
    }

    const fire = () => {
      clearTimeout(timer);
      timer = setTimeout(search, DEBOUNCE_MS);
    };
    input.addEventListener('input', fire);
    input.addEventListener('keyup', fire);
  }

  function bindAll() {
    document.querySelectorAll('[data-ink-pms-input]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
})();
